import { useQuery } from 'react-query';
import TranslationPenalty from '../../../models/TranslationPenalty';

function usePenaltyById(penaltyId?: string) {
    return useQuery<TranslationPenalty>(['penalties/', penaltyId], { enabled: !!penaltyId });
}

export default usePenaltyById;
